import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Button from '../Button';

import styles from './planOfferCard.module.scss';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';
import { MultilineText, renderMultilineText } from 'utils/renderMultilineText';

const PlanOfferCard = ({
  image,
  logo,
  currency,
  price,
  periodicity,
  tax,
  promotion1,
  promotion2,
  promotion3,
  whatIncludes,
  whatIncludes2,
  onWhatIncludesClicked,
  whatIncludesColor,
  contract,
  contract2,
  contractStyle,
  contractColor,
  onContractClicked,
  className,
  children,
}) => {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <div
        className={styles.container}
        style={{ backgroundImage: `url(${image})` }}
      >
        {logo ? (
          <img src={logo} className={styles.logo} alt="logo" />
        ) : (
          <span className={styles.logo} />
        )}
        <div className={styles.priceContainer}>
          <p className={styles.price}>
            <span className={styles.priceQuantity}>
              {renderMaxLengthText(currency, 3)} {renderMaxLengthText(price, 7)}
            </span>
            <span className={styles.periodicity}>
              {renderMaxLengthText(periodicity, 11)}
            </span>
          </p>
        </div>
        <p className={styles.tax}>{renderMaxLengthText(tax, 12)}</p>

        <span className={styles.promotion1}>
          {renderMaxLengthText(promotion1, 22)}
        </span>
        <span className={styles.promotion2}>
          {renderMaxLengthText(promotion2, 22)}
        </span>
        <span className={styles.promotion3}>
          {renderMaxLengthText(promotion3, 22)}
        </span>

        <div className={styles.buttonsContainer}>
          <Button
            type="whatIncludes"
            onClick={onWhatIncludesClicked}
            className={styles.whatIncludesButton}
            style={{
              backgroundColor: whatIncludesColor,
              ...(whatIncludes && whatIncludes2
                ? { padding: 0 }
                : {
                    padding: '12px 9px',
                  }),
            }}
          >
            <p className={styles.whatIncludes1}>
              {renderMaxLengthText(whatIncludes, 20)}
            </p>
            <p className={styles.whatIncludes2}>
              {renderMaxLengthText(whatIncludes2, 20)}
            </p>
          </Button>
          <Button
            type="red"
            onClick={onContractClicked}
            className={styles.contractButton}
            style={{
              ...contractStyle,
              backgroundColor: contractColor,
              ...(contract && contract2
                ? { padding: 0 }
                : {
                    padding: '12px 9px',
                  }),
            }}
          >
            <p className={styles.contract1}>
              {renderMaxLengthText(contract, 20)}
            </p>
            <p className={styles.contract2}>
              {renderMaxLengthText(contract2, 20)}
            </p>
          </Button>
        </div>

        {children}
      </div>
    </div>
  );
};

PlanOfferCard.propTypes = {
  image: PropTypes.string,
  classes: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};

PlanOfferCard.defaultProps = {
  imageAlt: 'panel',
  classes: [],
};

export default PlanOfferCard;
